import { Enum } from "./enum.class";
import EnumItem from "./enumItem.class";

/**
 * Enum de status de tarefa
 * Representa os status disponíveis para tarefas do sistema
 */
class StatusTarefaEnum extends Enum {
    constructor() {
        super();
        this.AGUARDANDO_CLIENTE = new StatusTarefaEnumItem(1, 'AGUARDANDO_CLIENTE', 'Aguardando cliente', 'is-info');
        this.RECEBIDOS = new StatusTarefaEnumItem(2, 'RECEBIDOS', 'Recebidos', 'is-success');
        this.ATRASADAS = new StatusTarefaEnumItem(5, 'ATRASADAS', 'Atrasadas', 'is-danger');
        this.A_FAZER = new StatusTarefaEnumItem(3, 'A_FAZER', 'A fazer', 'is-info');
        this.CONCLUIDO = new StatusTarefaEnumItem(4, 'CONCLUIDO', 'Concluído', 'is-success');
        this.AGUARDANDO_DADOS = new StatusTarefaEnumItem(6, 'AGUARDANDO_DADOS', 'Aguardando dados', 'is-link');
        this.A_CONFERIR = new StatusTarefaEnumItem(7, 'A_CONFERIR', 'A conferir', 'is-warning');
        this.PARALISADA = new StatusTarefaEnumItem(8, 'PARALISADA', 'Paralisada', 'is-light');
    }
}

/**
 * Item do enum de status de tarefa
 * @extends EnumItem
 */
class StatusTarefaEnumItem extends EnumItem {
    /**
     * @param {number} id - ID do status
     * @param {string} key - Chave do status
     * @param {string} texto - Texto de exibição do status
     * @param {string} cor - Classe Bulma de cor (ex: 'is-success', 'is-danger')
     */
    constructor(id, key, texto, cor) {
        super(id, key);
        this.texto = texto;
        this.cor = cor;
    }

    /**
     * Retorna o texto de exibição do status
     * @returns {string} Texto do status
     */
    getTexto() {
        return this.texto;
    }

    /**
     * Retorna a classe Bulma de cor do status
     * @returns {string} Classe de cor
     */
    getCor() {
        return this.cor;
    }
}

export const statusTarefaEnum = new StatusTarefaEnum();
